/**
 * App version (force-update) API service layer.
 *
 * Pure axios wrappers around the `/api/app-versions` endpoints. The GET is
 * public; the PUT requires an admin token (attached automatically by the axios
 * interceptor in `api/index.js`).
 */
import { api } from "api";
import { getAppVersions, updateAppVersion } from "api/apiURLs";

/**
 * Fetch the full apps × platforms grid:
 *   { customer: { ios, android }, vendor: {...}, driver: {...} }
 * where each platform is `{ minVersion, downloadUrl }`.
 */
export const fetchAppVersions = async () => {
    const response = await api.get(getAppVersions);
    return response.data;
};

/**
 * Save one app's iOS + Android config.
 *
 * @param {{ app: string, versions: { ios?: { minVersion: string, downloadUrl: string }, android?: { minVersion: string, downloadUrl: string } } }} params
 */
export const saveAppVersion = async ({ app, versions }) => {
    const response = await api.put(`${updateAppVersion}${app}`, versions);
    return response.data;
};
